import './OptOutModal.scss';
import {
  optOutOfClientMission,
  getClientMissions
} from 'services/Rest';
import React, { useState } from 'react';
import {educationAuthTokenUrls} from 'services/Externals';
import { connect } from 'react-redux';
import { isDesktopLayout } from 'state/view/ViewSelectors';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';

import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import Store from 'state/Store';
import { clearOnboardingMaintenanceOptOut } from 'state/onboardingMaintenance/OnboardingMaintenanceActions';

const OptOutModal = ({
  missionName,
  agreementKey,
  isDesktopLayout,
  requestStatus
}) => {
  const [optOutFailedCounter, setFailedCounter] = useState(0);
  return (
    <DeleteModal
      className={'opt-out-modal'}
      id={'opt-out-funding' + agreementKey.agreementID}
      size={isDesktopLayout ? 'medium' : 'jumbo'}
      linkContent={'Dismiss'}
      closeOnClickOut={false}
      ctaButtons={true}
      dataMetricsLocation="PU"
      requestStatus={requestStatus}
      failedCounter={optOutFailedCounter}
      setFailedCounter={setFailedCounter}
      CTA={() => optOutOfClientMission(agreementKey, missionName, () => { getClientMissions(); Store.dispatch(clearOnboardingMaintenanceOptOut()); })}
      leftButtonVariant={'tertiary'}
      leftButtonLabel={'Cancel'}
      leftButtonScale={'jumbo'}
      rightButtonVariant={'negative'}
      rightButtonLabel={
        optOutFailedCounter > 0 ? 'Try Again' : "I'll Do This Later"
      }
      rightButtonScale={'jumbo'}
      receivedDeleteSuccess={requestStatus['updateMission'] === 'RECEIVED'}
      receivedDeleteError={requestStatus['updateMission'] === 'ERROR'}>
      <div>
        {optOutFailedCounter > 0 && (
          <div>
            <h2>Something went wrong</h2>
            <div className="delete-line">
              There was an issue with your request. Please try again later. If the problem persists, you can
              {' '}
              <a
                className="error-page-link"
                href={educationAuthTokenUrls.contactUrl}
                rel="noreferrer"
                target="_blank"
              >
                Contact Us
              </a>
              .
            </div>
          </div>
        )}
        {optOutFailedCounter === 0 && (
          <div>
            <h2>Are you sure?</h2>
            <div className={'subheading'}>
              You will need to fund your sweep account to place Brokerage trade
              orders.
            </div>
          </div>
        )}
      </div>
    </DeleteModal>
  );
};

const mapStateToProps = (state) => ({
  isDesktopLayout: isDesktopLayout(state),
  requestStatus: getRequestStatus(state)
});

export default connect(mapStateToProps)(OptOutModal);
